// API Client für ZHB_T49_GT Hilfstabelle
// Liefert Mapping Fraktionsnummer → Fraktionsname (ZEITFENSTER_GT)

import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./auth";

export interface ZhbT49Gt {
    FRAKTION: string;
    ZEITFENSTER_GT: string;
}

export async function fetchZhbT49GtMap(): Promise<Record<string, string>> {
    const response = await fetch(`${API_BASE_URL}/api/zhb-t49-gt`, {
        headers: getAuthHeaders(),
        credentials: "include"
    });
    if (!response.ok) throw new Error("Fehler beim Laden der Fraktionsnamen");
    const data = await response.json();
    // Annahme: data ist ein Array von Objekten mit FRAKTION und ZEITFENSTER_GT
    const map: Record<string, string> = {};
    for (const row of data) {
        if (row.FRAKTION && row.ZEITFENSTER_GT) {
            map[row.FRAKTION] = row.ZEITFENSTER_GT;
        }
    }
    return map;
}
